module.exports = __webpack_public_path__ + "img/sound-run.32b092ae.png";